<style lang="scss" scoped>
.btn-action {
  height: 1.8rem;
}
.commands {
  padding: 10px 0
}

div.croppa-container {
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.15);
  margin-bottom: 0 !important;
}

.crop {
  &__wrapper {
    position: relative;
  }

  &__remove {
    position: absolute;
    top: 55px;
    right: calc(50% - 160px);

    &-btn {
      align-items: center;
      background: #f85359;
      color: white;
      display: flex;
      justify-content: center;
      height: 20px;
      width: 20px;

      i {
        height: 11px;
        width: 11px;
      }
    }
  }

  &__zoom {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 0 auto;
    width: 300px;

    &-in {}
    &-out {
      margin-left: 10px;
    }

    &-in,
    &-out {
      &-btn {
        align-items: center;
        background-color: #4cade5;
        color: white;
        display: flex;
        height: 22px;
        justify-content: center;
        width: 22px;

        i {
          height: 11px;
          width: 11px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="modal active" v-if="active" id="modal-id">
    <a class="modal-overlay" aria-label="Close" @click="dismiss()"></a>
    <div class="modal-container">
      <div class="modal-header">
        <a class="btn btn-clear float-right" aria-label="Close" @click="dismiss()"></a>
        <h3>Selecionar foto do perfil</h3>
      </div>
      <div class="modal-body">
        <div class="content text-center">
          <croppa
            v-model="file"
            :ref="'avatar'"
            :placeholder-font-size="14"
            :accept="'image/*'"
            :width="300"
            :height="300"
            :zoom-speed="40"
            :quality="1"
            :disabled="disableCroppa"
            :placeholder="'Clique ou arraste uma imagem aqui'"
            @new-image="setImage()"
            @image-remove="clearImage()"
            :key="restart"
            :show-remove-button="false"
          >

            <transition name="fade" v-if="hasImage && !disableCroppa">
              <div class="crop__remove">
                <button
                  v-if="!initialImage"
                  @click="clearImage()"
                  class="btn btn-action s-circle crop__remove-btn">
                  <i class="icon icon-cross"></i>
                </button>
              </div>
            </transition>

            <img slot="initial" :src="image" v-if="image && hasImage">

            <transition name="fade" v-if="hasImage">
              <div class="commands" v-if="!disableCroppa">
                <!-- <button @mousedown="$refs.avatar.zoomIn()"  class="btn btn-action s-circle"><i class="icon icon-plus"></i></button>
                <button @mousedown="$refs.avatar.zoomOut()"   class="btn btn-action s-circle"><i class="icon icon-minus"></i></button>
                <button @click="clearImage()" class="btn btn-action s-circle"><i class="icon icon-cross"></i></button> -->

                <div class="crop__zoom">
                  <div class="crop__zoom-in">
                    <button
                      v-if="!initialImage"
                      @mousedown="$refs.avatar.zoomIn()"
                      class="btn btn-action s-circle crop__zoom-in-btn">
                      <i class="icon icon-plus"></i>
                    </button>
                  </div>

                  <div class="crop__zoom-out">
                    <button
                      v-if="!initialImage"
                      @mousedown="$refs.avatar.zoomOut()"
                      class="btn btn-action s-circle crop__zoom-out-btn">
                      <i class="icon icon-minus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="commands" v-else >
                <button :disabled="sending" @click="clearImage()" class="btn btn-blue">Adicionar nova foto</button>
              </div>
            </transition>
          </croppa>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          @click="dismiss()"
          :disabled="sending"
          :class="sending ? 'disabled' : ''"
          class="btn btn-md cancel btn-green"
        >Cancelar</button>
        <dr-submit :sending="sending" @click.native="send()" text="Definir como foto padrão"></dr-submit>
      </div>
    </div>
  </div>
</template>

<script>
import Croppa from 'vue-croppa'
import drSubmit from '@/components/form/submit'

export default {
  components: {
    croppa: Croppa.component,
    drSubmit
  },
  props: ['active', 'image'],
  data () {
    return {
      restart: 0,
      file: null,
      sending: false,
      hasImage: true,
      disableCroppa: true,
      mouseEvt: null,
      initialImage: null
    }
  },
  methods: {
    setInterval (f, time) {
      return setInterval(f, time)
    },
    clearInterval (id) {
      return clearInterval(id)
    },
    dismiss () {
      if (!this.sending) {
        this.$emit('status', false)
      }
    },
    clearImage () {
      this.disableCroppa = false
      this.hasImage = false
      this.$refs.avatar.remove()
      setTimeout(() => { // hack para CORS no firefox (e possivelmente outros)
        this.$refs.avatar.refresh()
        this.restart = this.restart + 1
      }, 100)
    },
    setImage () {
      this.hasImage = true
    },
    send () {
      this.disableCroppa = true
      this.sending = true
      this.fn_SHOW_PROGRESS()

      this.$refs.avatar.generateBlob((blob) => {
        if (!blob) {
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Você precisar escolher um arquivo de imagem válido antes de continuar.',
            size: 'md',
            active: true
          })
          this.disableCroppa = false
          this.sending = false
          this.fn_HIDE_PROGRESS()
          return
        }

        function getFormData (object) {
          const formData = new FormData()
          Object.keys(object).forEach(key => formData.append(key, object[key]))
          return formData
        }

        let headers = this.fn_COPY_OBJECT(this.$store.getters.getAuthHeader)
        let boundary = Math.random().toString().substr(2)
        headers.headers['Content-Type'] = `multipart/form-data; charset=utf-8; boundary=${boundary}`
        blob.lastModifiedDate = new Date()
        blob.name = 'avatar'
        let data = { 'profile_picture[profilePictureFile][file]': blob }
        let fdata = getFormData(data)
        this.$http.post(`/${this.fn_IS_DOCTOR() ? 'doctor' : 'user'}/profile_picture`, fdata, headers).then(
          (res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Imagem salva com sucesso',
              size: 'md',
              active: true
            })
            this.sending = false
            this.$emit('newImage', this.$refs.avatar.img.src)
            this.fn_HIDE_PROGRESS()
            this.dismiss()
          }
        ).catch(
          (err) => {
            console.log(err)
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
            this.sending = false
            this.fn_HIDE_PROGRESS()
          }
        )
      }, 'image/png', 100)
    }

  }
}
</script>
